module.exports = __webpack_public_path__ + "static/media/mycart_product_1.1fa46f19.png";